/**
 * @file
 * Vue app for delivery table.
 */

'use strict';

import Vue from 'vue';
import axios from 'axios';

Vue.component('delivery-table', {
  props: {
    service: {
      type: String,
      default: '',
    },
    showStock: {
      type: Boolean,
      default: false,
    },
    showSeeds: {
      type: Boolean,
      default: false,
    },
  },
  template: `
    <div class="pdt">
      <div class="pdt-togglers" v-if="service !== 'all'">
        <div class="pdt-togglers-item" :class="{'pdt-togglers-item--active': type == 'selfpickup'}" @click="setType('selfpickup')">
          <div class="g-form-radio-wrapper">
            <input type="radio" class="g-form-radio-field" :checked="type == 'selfpickup'" />
            <div class="g-form-radio-overlay"></div>
          </div>
          {{ labels.selfpickup }}
        </div>
        <div class="pdt-togglers-item" :class="{'pdt-togglers-item--active': type == 'courier'}" @click="setType('courier')">
          <div class="g-form-radio-wrapper">
            <input type="radio" class="g-form-radio-field" :checked="type == 'courier'" />
            <div class="g-form-radio-overlay"></div>
          </div>
          {{ labels.courier }}
        </div>
      </div>
      <form action="?" autocomplete="off" class="nauth pdf-form" @submit.prevent>
        <div class="pr-form-row">
          <div class="pr-form-col pr-form-col--100">
            <label class="pr-form-label">
              Воспользуйтесь поиском по региону
            </label>
            <div class="pr-select">
              <div class="pr-select-field">
                <input type="text" class="form-control pr-form-control" placeholder="Начните вводить название региона" v-model="regionName">
              </div>
            </div>
          </div>
        </div>
      </form>
      <table :class="{'pdt-table': type == 'selfpickup'}" @click.prevent="showSwipe = false">
        <thead>
          <tr>
            <th>Регион</th>
            <th v-if="service === 'all'">Транспортная компания</th>
            <th>Стоимость</th>
            <th v-if="type == 'selfpickup' && showStock">Стоимость для наличия</th>
            <th v-if="showSeeds">Стоимость для семян</th>
            <th>Срок в пути</th>
            <th>Гарантия</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="country in filteredList">
            <template v-if="Object.keys(country.list).length">
              <tr v-if="type == 'selfpickup' && service != 'ozon'">
                <td colspan="5">
                  <b>
                    {{ country.name }}
                  </b>
                </td>
              </tr>
              <template v-for="region, regionName in country.list">
                <tr v-for="item in region">
                  <td>
                    {{ item.city || regionName }}
                  </td>
                  <td v-if="service === 'all'">
                    {{ item.service }}
                  </td>
                  <td>
                    <template v-if="item.price">
                      {{ item.price }} ₽
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <td v-if="type == 'selfpickup' && showStock">
                    <template v-if="item.stockPrice">
                      {{ item.stockPrice }} ₽
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <td v-if="showSeeds">
                    <template v-if="item.price_for_seeds">
                      {{ item.price_for_seeds }} ₽
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <td>
                    <template v-if="item.days.from">
                      {{ item.days.from }} - {{ item.days.to }} дней
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <td>
                    <template v-if="item.guarantee">
                      {{ item.guarantee }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                </tr>
              </template>
            </template>
          </template>
          <template v-if="!Object.keys(filteredList).length">
            <tr>
              <td colspan="5">
                {{ service === 'all' && !regionName ? 'Тарифы появятся после заполнения региона' : 'Регион не найден, проверьте правильно ли введен регион' }}
              </td>
            </tr>
          </template>
        </tbody>
        <template v-if="swipeActive">
          <div class="pdt-table-overlay"></div>
          <div class="pdt-swipe">
            <svg class="pdt-swipe-icon" width="96px" height="96px" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 120 120" xml:space="preserve">
              <path fill="#FFFFFF" d="M92.68,19.083c-1.512-2.583-3.158-5.137-4.938-7.649c-0.382-0.539-0.806-0.775-1.499-0.702c-0.694,0.074-0.946,0.58-1.083,1.17c-0.336,1.462-0.672,2.924-1.009,4.386c-18.239-4.197-37.304-3.577-55.299,1.86c-1.073,0.323-1.828,1.621-1.515,2.571c0.313,0.949,1.646,1.566,2.672,1.258c17.326-5.234,35.683-5.832,53.245-1.791c-0.262,1.137-0.523,2.274-0.785,3.411c-0.136,0.592-0.143,1.149,0.36,1.507s0.922,0.33,1.453,0.021c2.477-1.437,5.062-2.781,7.751-4.021C92.82,20.741,93.122,19.841,92.68,19.083z"/>
              <path fill="#FFFFFF" d="M81.003,67.365c-0.846-0.308-1.872-0.394-2.51-0.416c0.453-1.611,0.317-3.312-0.397-4.845c-0.79-1.695-2.192-2.98-3.949-3.62c-1.51-0.548-3.185-0.547-4.645-0.049c0.033-0.953-0.118-1.884-0.452-2.742c-0.662-1.696-1.998-2.984-3.761-3.625c-1.769-0.643-3.697-0.504-5.268,0.281l5.726-17.673c1.462-4.018-0.265-8.077-4.016-9.444c-0.792-0.288-1.602-0.434-2.407-0.434c-2.97,0-5.615,1.997-6.75,5.117L42.266,60.239c-0.914,0.137-2.331,0.473-4.299,1.278c-6.79,2.781-12.541,13.389-9.938,24.163c2.896,11.998,8.91,18.856,20.111,22.933c3.145,1.145,6.1,1.725,8.781,1.725c6.644,0,10.803-3.411,14.493-6.905c5.07-4.8,13.282-27.257,13.629-28.212C86.136,72.217,84.249,68.546,81.003,67.365zM82.225,74.195c-2.298,6.312-9.088,23.476-12.873,27.059c-3.387,3.207-6.886,6.084-12.431,6.084c-2.331,0-4.94-0.52-7.756-1.544c-10.275-3.739-15.555-9.771-18.221-20.817c-1.554-6.434,0.852-17.689,8.159-20.683c0.792-0.324,1.467-0.557,2.029-0.724l-3.367,9.907c-0.267,0.784,0.153,1.637,0.938,1.903c0.785,0.266,1.637-0.154,1.902-0.938l14.798-43.533c0.873-2.399,3.126-3.652,5.302-2.859c2.215,0.807,3.129,3.109,2.206,5.65l-8.637,26.653c-0.237,0.732,0.118,1.525,0.822,1.835c0.706,0.311,1.529,0.037,1.909-0.633l2.252-3.969c0.041-0.073,0.076-0.149,0.105-0.228c0.758-2.086,2.9-3.2,4.899-2.472c0.954,0.347,1.644,1.003,1.992,1.896c0.354,0.907,0.334,1.996-0.055,3.066l-1.023,2.812c-0.001,0.002-0.002,0.004-0.002,0.006c-0.283,0.779,0.118,1.64,0.896,1.923c0.779,0.283,1.639-0.118,1.922-0.897c0.573-1.574,2.084-2.633,3.76-2.633c0.465,0,0.925,0.082,1.367,0.243c1.004,0.365,1.806,1.101,2.257,2.068s0.499,2.055,0.134,3.059l-2.223,6.108c-0.283,0.777,0.118,1.639,0.896,1.922c0.774,0.283,1.638-0.117,1.922-0.896l1.306-3.586c0.173-0.02,0.405-0.035,0.698-0.035c0.72,0,1.471,0.097,1.868,0.241C81.66,70.797,82.752,72.746,82.225,74.195z"/>
            </svg>
          </div>
        </template>
      </table>
    </div>
  `,
  data() {
    return {
      data: {},
      showSwipe: true,
      regionName: '',
      type: 'selfpickup',
    }
  },
  methods: {
    async getList(type) {
      await axios.get(`/api/faq/get-delivery-table/${this.service}/${type}`).then((response) => {
        this.data = response.data;
      });

      this.$nextTick(() => {
        this.swipe();
      });
    },
    async setType(type) {
      if (this.type == type) {
        return;
      }

      await this.getList(type);
      this.type = type;
    },
    swipe() {
      const swipeIcon = document.querySelector('.pdt-swipe');
      if (!this.showSwipe || this.type !== 'selfpickup' || !swipeIcon) {
        return;
      }

      const table = document.querySelector('.pdt-table');
      const tableHeight = table.offsetHeight;
      const tableTop = table.offsetTop;
      const swipeIconHeight = swipeIcon.offsetHeight / 2;

      document.addEventListener('scroll', () => {
        const top = window.innerHeight / 2 - swipeIconHeight > tableTop - window.scrollY + 50;
        const bottom = tableTop + tableHeight - swipeIconHeight > window.scrollY + window.innerHeight / 2 + swipeIconHeight + 100;

        if (top && bottom) {
          swipeIcon.classList.add('pdt-swipe--fixed')
        }
        else {
          swipeIcon.classList.remove('pdt-swipe--fixed')
        }

        if (!bottom && tableTop < window.scrollY) {
          swipeIcon.classList.add('pdt-swipe--bottom');
        }
        else {
          swipeIcon.classList.remove('pdt-swipe--bottom');
        }
      });

      table.addEventListener('scroll', () => {
        if (table.scrollLeft !== 0) {
          this.showSwipe = false;
        }
      });
    }
  },
  created() {
    this.getList(this.type);
  },
  computed: {
    labels() {
      if (this.service === 'russian_post') {
        return {
          selfpickup: 'Доставка в отделение Почты России',
          courier: 'Доставка курьером Почты России'
        }
      }
      else {
        return {
          selfpickup: 'Доставка в пункт выдачи',
          courier: 'Доставка курьером'
        }
      }
    },
    filteredList() {
      if (!this.regionName) {
        return this.service === 'all' ? [] : this.data
      }

      const newData = JSON.parse(JSON.stringify(this.data));
      for (const countryKey in newData) {
        const country = newData[countryKey];

        for (const regionName in country.list) {
          if (!regionName.toLocaleLowerCase().includes(this.regionName.toLowerCase())) {
            delete newData[countryKey].list[regionName];
          }
        }

        if (!Object.keys(country.list).length) {
          delete newData[countryKey];
        }

      }

      return newData;
    },
    swipeActive() {
      return this.type === 'selfpickup' && this.showSwipe && this.isMobile;
    },
    isMobile() {
      if (window) {
        return window.innerWidth < 641
      }
    }
  },
});

new Vue({
  name: 'DeliveryTable',
  el: '#delivery-table',
  methods: {
    declOfNum(number, titles) {
      const cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },
  }
});
